import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ icon, label, value, sub, trend, color, loading }) => (
  <div className="bg-card border border-border rounded-xl p-5 flex flex-col gap-3 hover:shadow-md transition-shadow">
    <div className="flex items-center justify-between">
      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${color}`}>
        <Icon name={icon} size={18} className="text-white" />
      </div>
      {trend !== undefined && (
        <span className={`text-xs font-medium flex items-center gap-1 ${trend >= 0 ? 'text-green-500' : 'text-red-500'}`}>
          <Icon name={trend >= 0 ? 'TrendingUp' : 'TrendingDown'} size={12} />
          {Math.abs(trend)?.toFixed(1)}%
        </span>
      )}
    </div>
    {loading ? (
      <div className="space-y-2 animate-pulse">
        <div className="h-7 bg-muted rounded w-24" />
        <div className="h-4 bg-muted rounded w-32" />
      </div>
    ) : (
      <>
        <div className="text-2xl font-bold text-foreground">{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
        {sub && <div className="text-xs text-muted-foreground/70">{sub}</div>}
      </>
    )}
  </div>
);

const SellerStatsCards = ({ stats, loading }) => {
  const cards = [
    {
      icon: 'DollarSign',
      label: 'Total Revenue',
      value: `$${(stats?.totalRevenue || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      trend: stats?.revenueChange,
      color: 'bg-primary',
    },
    {
      icon: 'Zap',
      label: 'Active Auctions',
      value: stats?.activeAuctions || 0,
      sub: 'Live & Scheduled',
      color: 'bg-green-500',
    },
    {
      icon: 'CheckCircle',
      label: 'Completed Auctions',
      value: stats?.completedAuctions || 0,
      sub: 'Ended & Sold',
      color: 'bg-blue-500',
    },
    {
      icon: 'Users',
      label: 'Total Bids Received',
      value: (stats?.totalBidsReceived || 0)?.toLocaleString(),
      sub: `Avg ${(stats?.avgBidsPerAuction || 0)?.toFixed(1)} per auction`,
      color: 'bg-purple-500',
    },
    {
      icon: 'Target',
      label: 'Sell-Through Rate',
      value: `${(stats?.sellThroughRate || 0)?.toFixed(1)}%`,
      sub: 'Sold vs. Ended',
      color: 'bg-warning',
    },
    {
      icon: 'TrendingUp',
      label: 'Avg Sale Price',
      value: `$${(stats?.avgSalePrice || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      sub: 'Across sold auctions',
      color: 'bg-orange-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {cards?.map((card, i) => (
        <StatCard key={i} {...card} loading={loading} />
      ))}
    </div>
  );
};

export default SellerStatsCards;
